import BigNumber from 'bignumber.js'
import { DEFAULT_GAS_LIMIT, DEFAULT_TOKEN_DECIMAL } from 'config'
import getGasPrice from 'utils/getGasPrice'

const options = {
  gasLimit: DEFAULT_GAS_LIMIT,
}



export const mintGLITCH = async (
  glitchContract,
  walletAddress,
  price,
  amount
) => {
  const gasPrice = getGasPrice()
  const _userMaxMintSupply = '5';

  const response = await fetch(`.netlify/functions/g-signatures-get?walletAddress=${walletAddress}&price=${price}`, {
    headers: {
      security: walletAddress
    }
  });
  const {signature, currentTimestamp} = await response.json();
// console.log(
//   walletAddress,
//   amount,
//   price,
//   currentTimestamp,
//   signature
// )
  const tx = await glitchContract.mintGLITCH(
    walletAddress,
    amount,
    _userMaxMintSupply,
    price,
    currentTimestamp,
    signature,
    // {}
    { ...options, gasPrice }
  )
  const receipt = await tx.wait()
  return receipt.status
}
